import { useDispatch } from 'react-redux';
import { globalErrorResponse } from '../../../store/notifications/actions';
import { neverShowReserveReportVideoAgain } from './apiNeverShowReserveReportVideoAgain';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

export const useNeverShowReserveReportVideoAgainMutation = () => {
    const dispatch = useDispatch();
    return useMutation<AxiosResponse<void>, AxiosError>(neverShowReserveReportVideoAgain, {
        onError: error => {
            dispatch(globalErrorResponse(error));
        }
    });
};
